export default __webpack_public_path__ + "static/media/zeusImage.58a1caa1.png";